
<template>
  <div>
    <div v-if="hasAttachment">
      <div class="attachments">
        <div v-if="isAttachmentImage">
          <img :src="compFileBase64" style="width: 200px; height: 200px" />
        </div>
        <!-- <div>
          <label>{{ fileName }}</label>
        </div> -->
        <div class="mt-2">
          <a href="#" @click="discardImage($event)"
            ><label>{{ $t("geral.discard") }}</label></a
          >
        </div>
      </div>
    </div>
    <b-button size="sm" class="button" @click="openFileDialog">
      <i class="tim-icons icon-attach-87 mb-1 mr-2 ml-0"></i>
      {{ $t("geral.attachmentAdd") }} - single
    </b-button>
    <b-form-file
      id="file-input"
      class="file-input"
      :lang="$i18n.locale"
      :placeholder="$t('geral.escolhaArquivo')"
      :no-drop="true"
      v-on:change="handleFileUpload($event)"
      accept="image/*"
    >
    </b-form-file>
    <!-- <div>{{ compFileBase64 }}</div> -->
    <!-- <div>{{ file }}</div> -->
    <!-- <div>{{ fileBase64 }}</div> -->
  </div>
</template>

<script>
export default {
  name: "BaseAttachment",
  props: {
    attachment: String,
  },
  data: function () {
    return {
      //   fileName: "",
      //   fileBase64: null,
      alert: {
        error: "",
        success: "",
      },
    };
  },
  computed: {
    compFileBase64: {
      get: function () {
        return this.attachment;
      },
      set: function (newValue) {
        this.$emit("change", newValue);
      },
    },
    hasAttachment() {
      if (this.attachment == null) {
        return false;
      }
      if (this.attachment.length == 0) {
        return false;
      }
      return true;
    },
    isAttachmentImage() {
      if (this.attachment.startsWith("blob:") == true) return true;
      if (this.attachment.startsWith("data:image") == true) return true;
      return false;
    },
  },
  methods: {
    openFileDialog() {
      // this.$refs.attachmentFile.click();
      document.getElementById("file-input").click();
    },
    discardImage(e) {
      e.preventDefault();
      this.compFileBase64 = "";
    },
    // handleFileUpload(e) {
    //   this.file = e.target.files[0];
    // },
    handleFileUpload(event) {
      const fileElement = event.target;
      const file = fileElement.files[0];
      const reader = new FileReader();

      reader.addEventListener(
        "load",
        () => {
          // console.log("load img");
          // convert image file to base64 string
          //   this.fileName = file.name;
          this.compFileBase64 = reader.result;
        },
        false
      );

      console.log(file);
      if (file) {
        reader.readAsDataURL(file);
      }
    },
  },
};
</script>

<style scoped>
.attachments {
  border: 1px;
  border-color: #2b3553;
  border-radius: 0.4285rem;
  border-style: solid;
  margin-bottom: 10px;
  padding: 10px;
  text-align: center;
}
.button {
  max-width: 175px;
  padding-left: 15px;
  padding-right: 15px;
}
.file-input {
  display: none;
}
</style>